export default "__VITE_ASSET__BAtlHQG6__"